import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  useMediaQuery,
  LinearProgress,
} from '@mui/material';

import Sidebar from '../../components/sidebars/Sidebar _inventory';
import TopNav from '../../components/top_bars/TopNav_inventory';
import StatisticsCards from '../../components/top_bars/StatisticsCard';

import { useNavigate } from 'react-router-dom';

const Onboard_storekeeper = () => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  useEffect(() => {
    const storedPhone = localStorage.getItem('phoneNumber');
    if (storedPhone) {
      setPhoneNumber(storedPhone);
    }
  }, []);

  const handleSubmit = () => {
    if (phoneNumber.trim().length < 7) {
      alert('Please enter a valid phone number');
      return;
    }

    localStorage.setItem('phoneNumber', phoneNumber.trim());
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      navigate('/add_staff2'); 
    }, 3000); // 3 second delay
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          ml: isMobile ? 0 : sidebarOpen ? 30 : 5,
          maxWidth: '1400px',
          mx: 'auto',
          width: '100%',
        }}
      >
        <TopNav
          onLogout={() => {
            localStorage.removeItem('authToken');
            localStorage.removeItem('userProfile');
            localStorage.removeItem('phoneNumber');
          }}
          onNotificationClick={() => alert('You have new notifications!')}
          toggleSidebar={toggleSidebar}
        />

        <Box sx={{ mt: 2 }}>
          <StatisticsCards />
        </Box>

        <Grid container spacing={3} sx={{ mt: 4 }}>
          <Grid item xs={12}>
            <Paper
              elevation={4}
              sx={{
                p: 3,
                borderRadius: 4,
                width: '100%',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
              }}
            >
              <Typography variant="h6" gutterBottom>
                Enter Phone Number
              </Typography>

              <TextField
                label="Phone Number"
                fullWidth
                required
                sx={{ minWidth: '550px' }}
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                disabled={loading}
              />

              <Box sx={{ mt: 2 }}>
              <Button
  variant="contained"
  onClick={handleSubmit}
  disabled={loading}
  sx={{
    mt: 3,
    textTransform: 'none',
    fontWeight: 'bold',
    borderRadius: 2,
    backgroundColor: '#C84646', // Oxblood-like red
    '&:hover': {
      backgroundColor: '#b33c3c', // Slightly darker on hover
    },
  }}
>
  Submit
</Button>

              </Box>

              {loading && (
                <Box sx={{ mt: 3 }}>
                  <LinearProgress />
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Preparing your data...
                  </Typography>
                </Box>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Onboard_storekeeper;
